import { FamilyEvent, PartOfDay, TaskTemplate } from '../types/family';

export const partOrder: PartOfDay[] = ['jutro', 'popoldne', 'vecer'];

export const partLabels: Record<PartOfDay, string> = {
  jutro: 'Zjutraj',
  popoldne: 'Po šoli',
  vecer: 'Zvečer',
};

/** Tedenska in mesečna opravila niso dnevna skrb – prikažejo se v »Ta teden«. */
export function isWeeklyTask(t: TaskTemplate): boolean {
  return t.frequency?.kind === 'tedensko' || t.frequency?.kind === 'mesecno';
}

/** Bonus naloge brez nosilca ali dnevni bonus (npr. urejena soba) so goodies priložnosti, ne obveznosti. */
export function isOpportunityTask(t: TaskTemplate): boolean {
  return t.valueType === 'bonus' && t.group === 'hisa';
}

export function partOfDayOf(t: TaskTemplate): PartOfDay {
  if (t.partOfDay) return t.partOfDay;
  if (t.group === 'vecer') return 'vecer';
  return 'popoldne';
}

/** Zjutraj do 8.00, po šoli do 19.00, nato zvečer. */
export function partOfHour(hour: number): PartOfDay {
  if (hour < 8) return 'jutro';
  if (hour < 19) return 'popoldne';
  return 'vecer';
}

export function eventPart(e: FamilyEvent): PartOfDay {
  const hour = Number(e.start.split('.')[0]);
  return partOfHour(Number.isNaN(hour) ? 12 : hour);
}

export function currentPart(): PartOfDay {
  return partOfHour(new Date().getHours());
}
